<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن شماره</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.type.val"
                                        :description="form.type.inv"
                                        label="نوع"
                                        :options="[
                                            {value: 1, label:'تکی'},
                                            {value: 2, label:'آپلود فایل'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.type.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <label>از شماره</label>
                                    <model-select :options="numbers" v-model="form.from_number.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.from_number.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.full_deny.val"
                                        :description="form.full_deny.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: 'true', label:'فعال'},
                                            {value: 'false', label:'غیرفعال'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.full_deny.val=$event.target.value"
                                    />
                                </CCol>
                            </CRow>
                            <br>
                            <CRow>   
                                <CCol sm="3" v-if="form.type.val == 1">
                                    <CInput v-model="form.to_number.val" :description="form.to_number.inv" dir="ltr" label="به شماره" />
                                </CCol>
                                <CCol sm="3"  v-if="form.type.val == 2">
                                    <CInputFile label="آپلود فایل"
                                        @change="form.file.val=$event[0]"
                                        :description="form.file.inv"
                                    />
                                    <small>فرمت فایل باید txt باشد.</small>
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: {val: '', inv: '', v: { req: true, max: 8 }},
                from_number: {val: '', inv: '', v: { req: true, max: 64 }},
                to_number: {val: '', inv: '', v: { req: true, max: 64, spec: 'mobile_number'}},
                full_deny: {val: '', inv: '', v: { req: true, max: 8 }},
                file: {val: '', inv: '', v: { req: true }},
                type: {val: 0, inv: '', v: { req: true }},
			},
            disable: false,
            users: [],
            numbers: [],
        }
    },
    watch: {
        'form.user_id.val': {
            handler(){
                if(this.form.user_id.val != ''){
                    this.get_numbers();
                }
            }
        }
    },
    mounted(){
        this.get_users();
    },
    methods: {
        submit(){
            if(this.disable == false){
                if(this.form.type.val == 1){
                    const data = new FormData();
                    for (const key in this.form){
                        if(key != 'file' || key != 'type'){
                            data.set(key, this.form[key].val);
                        }
                    }
                    this.axios.post('custom_black_lists/', data)
                        .then(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'افزودن با موفقیت انجام شد.'
                            });
                            for (const key in this.form){
                                this.form[key].val = '';
                            }
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                } else if(this.form.type.val == 2){
                    const reader = new FileReader();
                    reader.readAsDataURL(this.form.file.val);
                    reader.onload = () => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'فایل در حال آپلود است. لطفا صبور باشید.'
                        });
                        this.axios.post('custom_black_lists/', data)
                            .then(res => {
                                const data = new FormData();
                                data.set('base64_file', reader.result.split('base64,')[1]);
                                data.set('file_type', reader.result.split(':').pop().split(';')[0]);
                                for (const key in this.form){
                                    if(key != 'to_number' || key != 'type'){
                                        data.set(key, this.form[key].val);
                                    }
                                }
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    text: 'ارسال با موفقیت انجام شد.'
                                });
                            })
                            .catch(() => {
                                this.$notify({
                                    group: 'foo',
                                    type: 'error',
                                    text: 'خطا! لطفا مجددا تلاش کنید.'
                                });
                            })
                    }
                }

                
            }
        },
        get_users(){
            this.axios.get('users/?type=view_user_nums')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({value: val.id, text: `${val.id} - ${val.name}`})
                    });
                })
        },
        get_numbers(){
            this.numbers = [];
            this.axios.get('user_nums/'
                + '?user_id=' + this.form.user_id.val)
                .then(res => {
                    res.data.map(val => {
                        this.numbers.push({value: val.number, text: `${val.number}`});
                    });
                })
        },
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_custom_black_lists == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
